import React from 'react'
import { Modal } from 'antd'
import { get } from 'lodash'
import images from 'Themes/Images'
import { loadCourseSuccess } from '../../../Home/actions'
import { hideDeleteModal } from '../../actions'
import { deleteCourse } from '../../../Admin/actions'
import './styles.scss'

const DeleteCourseModal = ({ course, dispatch, showDeleteModal }) => {
  const handleOk = () => {
    dispatch(deleteCourse(course.id))
    dispatch(hideDeleteModal())
  }
  const handleCancel = () => {
    dispatch(loadCourseSuccess(null))
    dispatch(hideDeleteModal())
  }
  return (
    <Modal visible={showDeleteModal} footer={null} onCancel={handleCancel}>
      <div className="ld-modal">
        <div className="ld-modal__icon">
          <img src={images.admin.trash_icon} alt="" width="25" height="29" />
        </div>
        <div className="ld-modal__warning">
          Are you sure you want to delete {get(course, 'name', '')}?
        </div>
        <div className="ld-modal__label">
          You will not be able to recover this later.
        </div>
        <div className="ld-modal__btn__ok">
          <button className="delete-btn" onClick={handleOk}>
            <img
              src={images.admin.trash_white_icon}
              alt=""
              style={{ fill: '#fff' }}
              className="trash-icon"
            />
            <span>Delete forever</span>
          </button>
        </div>
        <div className="ld-modal__btn__cancel">
          <button className="tertiary-btn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteCourseModal
